import { DASHBOARD_ROUTE } from './consts';

export default (app) => {
    const fulfillmentMenuItem = app.sideMenuItems.getItem('fulfillment');
    if (fulfillmentMenuItem) {
        fulfillmentMenuItem.items.push({
            label: 'InterOffice',
            link: DASHBOARD_ROUTE,
            icon: 'customers',
        });
    }
    app.sideMenuItems.changeItem('fulfillment', fulfillmentMenuItem);
};
